module.exports = __webpack_public_path__ + "img/down_point_filtered_hover.14590f46.svg";